/**
 * External dependencies
 */
import React from "react";
import { connect } from "react-redux";
import { Box } from "@towersystems/towersystems-design-system";
import page from "page";

/**
 * Internal dependencies
 */
import UserMenuDropdown from "blocks/user-menu-dropdown";
import { checkCurrentPath } from "layout/utils";
import Link from "./link";
import BaseTopbar from "./index";
import { getLayoutId } from "state/dashboard/selectors";
import LocationFilterDropdown from "blocks/location-filter-dropdown";
import SelectReportPopver from "blocks/select-report-popover";
import { getAllLayouts } from "state/dashboard-layouts/selectors";
import { useMediaQuery } from "react-responsive";

/**
 * Style dependencies
 */
import "./styles.scss";
import logo from "assets/images/logo_white.png";

const maxLinksBeforeBreak = 4;

const Topbar = ({ layoutId, path, dashboards }) => {
  const isMobile = useMediaQuery({ maxWidth: "1150px" });

  const shownLinks = dashboards.slice(0, maxLinksBeforeBreak);
  const remainingLinks = dashboards.slice(maxLinksBeforeBreak);

  const showMoreDropdown = false == isMobile && remainingLinks.length >= 1 && (
    <>
      <Box className="topbar__seperator" />
      <SelectReportPopver
        dashboardfilterFn={(d) => {
          return remainingLinks.map((l) => l.id).includes(d.id);
        }}
        labelMarkup={`${remainingLinks.length} more...`}
      />
    </>
  );

  const navLinks = (
    <Box className="topbar__links" display="flex" alignItems="center">
      <Link
        label="Deck"
        selected={checkCurrentPath("/decks", path)}
        onClick={() => page(`/decks/${layoutId}`)}
      />
      <Link
        label="Views"
        selected={checkCurrentPath("/reports", path)}
        onClick={() => page("/reports/my-reports")}
      />
    </Box>
  );

  const deckNavLinks = (
    <Box className="topbar__links" display="flex" alignItems="center">
      {(isMobile ? dashboards : shownLinks).map((d, i) => {
        return (
          <>
            <Link
              label={d.name}
              selected={d.id == layoutId}
              onClick={() => page(`/decks/${d.id}`)}
            />
            {i < shownLinks.length - 1 && !isMobile && (
              <Box className="topbar__seperator" />
            )}
          </>
        );
      })}
      {showMoreDropdown}
      {isMobile && (
        <>
          <Link
            label="My Account"
            selected={checkCurrentPath("/me", path)}
            onClick={() => page("/me")}
          />
          <Link label="Logout" onClick={() => page("/logout")} />
        </>
      )}
    </Box>
  );

  const mobileMarkup = (
    <div className="topbar__mobile-content">
      <Box>{deckNavLinks}</Box>
    </div>
  );

  return (
    <BaseTopbar mobileChildren={mobileMarkup}>
      <Box
        position="relative"
        display="flex"
        justifyContent="spaceBetween"
        alignItems="center"
        width="full"
      >
        <Box display="flex" justifyContent="center" alignItems="center">
          <img src={logo} alt="Logo" style={{ height: 40, marginRight: 25 }} />
          <div>{deckNavLinks}</div>
        </Box>
        <Box display="flex" alignItems="center">
          <LocationFilterDropdown />
          <Box className="topbar__seperator" />
          <UserMenuDropdown />
        </Box>
      </Box>
    </BaseTopbar>
  );
};

export default connect((state) => ({
  layoutId: getLayoutId(state),
  dashboards: getAllLayouts(state),
  activeDashboardId: getLayoutId(state),
}))(Topbar);
